import { Box, Text } from '@air/zephyr';

import { AgencyContainer } from '~/old-marketing/components/agency/AgencyContainer';
import { AgencyList } from '~/old-marketing/components/agency/AgencyList/AgencyList';
import { AgencySectionTitle } from '~/old-marketing/components/agency/AgencySectionTitle';
import { LimitedAgencyData } from '~/old-marketing/components/types/custom-types';

export interface AgenciesListSectionProps {
  agencies?: LimitedAgencyData[];
}

export const AgenciesListSection = ({ agencies }: AgenciesListSectionProps) => {
  return (
    <Box as="section" tx={{ pb: 156 }}>
      <AgencyContainer>
        <Box tx={{ maxWidth: 694, mx: 'auto', mb: 40, textAlign: ['left', 'center'] }}>
          <AgencySectionTitle>The List</AgencySectionTitle>

          <Text as="p" tx={{ color: 'pigeon700' }} variant="text-ui-18">
            Want to explore by services, location, or size? Browse our full library of 1000+ agencies below. Select
            filters to narrow down your search.
          </Text>
        </Box>

        {agencies && <AgencyList agencies={agencies} />}
      </AgencyContainer>
    </Box>
  );
};
